import { render, staticRenderFns } from "./NewDashboard.vue?vue&type=template&id=762f8514&scoped=true"
import script from "./NewDashboard.vue?vue&type=script&lang=js"
export * from "./NewDashboard.vue?vue&type=script&lang=js"
import style0 from "./NewDashboard.vue?vue&type=style&index=0&id=762f8514&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762f8514",
  null
  
)

export default component.exports